import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {inject, Injectable} from '@angular/core';

import {environment} from "@numizmat/environments";
import {AdCategoryResponse} from "@numizmat/services-models/nomenclature";

@Injectable({
  providedIn: 'root'
})
export class AdCategoryApiService {
  private httpClient: HttpClient = inject(HttpClient);

  private adCategoryController: string = 'adCategory';

  public getAllAdCategories(): Observable<AdCategoryResponse[]> {
    const endpoint: string = `${environment.apiNomenclatureUrl}/${this.adCategoryController}/all`;
    return this.httpClient.get<AdCategoryResponse[]>(endpoint);
  }
}
